<template>
  <div id="app" data-app>
    <router-view />
  </div>
</template>

<script>
import store from './store'
import { SUPPORTED_LOCALES } from './constants/locale'

export default {
  name: 'App',
  data: function () {
    return {
      path: '/',
      locales: SUPPORTED_LOCALES
    }
  },
  computed: {
    locale () {
      return store.getters.locale
    }
  },
  watch: {
    $route (to) {
      this.path = this.locale.base ? to.path.substring(this.locale.base.length) : to.path
    }
  },
  created () {
    document.title = process.env.VUE_APP_TITLE
  }
}
</script>

<style scope>
@import './assets/css/swiper.min.css';
@import './assets/css/main.css';
</style>
